var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClientOnly',[_c('section',{staticClass:"md:pb-20"},[_c(_vm.CartComponent,{tag:"component"}),_vm._v(" "),_c('evidence-products')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }